export const hasRole = (role, user) => {
  if (!role || !user) {
    return false;
  }

  return (
    (user[`${process.env.NX_PUBLIC_AUTH0_NAMESPACE}/roles`] || []).indexOf(role) !== -1
  );
};

export const hasAnyRole = (roles, user) => (roles || []).some((role) => hasRole(role, user));
